import { formatDateForMySQL } from "components/formatDate";
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";
import { SendNotification } from "components/SendNotification";

export const SaveServiceRequest = async (serviceRequest,navigate,entityType = 'Request') => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
        let Payload  =
        {
            "requestID": serviceRequest.requestID,
            "requestTitle": serviceRequest.requestTitle,
            "reqDescription": serviceRequest.reqDescription,              
            "isDeposit": serviceRequest.isDeposit || false,
            "depositAmount": serviceRequest.depositAmount || 0,
            "completeWorkBy": serviceRequest?.completeWorkBy !== '0001-01-01T00:00:00' && serviceRequest?.completeWorkBy? formatDateForMySQL( new Date(serviceRequest.completeWorkBy)) :  '0001-01-01T00:00:00',
            "customerID": serviceRequest.customerID,
            "jobSiteID": serviceRequest.jobSiteID,
            "jobsiteContactID": serviceRequest.jobsiteContactID,
            "requestSource": "Internal",
            "status": serviceRequest?.status? serviceRequest?.status : "Submitted" ,
            "availabilityTime": Array.isArray(serviceRequest.availabilityTime)
            ? serviceRequest.availabilityTime
            : JSON.parse(serviceRequest.availabilityTime || "[]"),
            "availabilityDays": Array.isArray(serviceRequest.availabilityDays)
            ? serviceRequest.availabilityDays
            : JSON.parse(serviceRequest.availabilityDays || "[]"),
            "tags": serviceRequest.tags,
            "assignedToUsers": normalizeToUserIDs(serviceRequest.assignedToUsers), // Ensure this is an array of objects with userID property
            "entityType": entityType,
            "isArrived": false,
        };

          //  console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/ServiceRequest/saveServiceRequest`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
  
      
      const data = await response.json();                      
      // console.log(data)
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        SendNotification(navigate);
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

function normalizeToUserIDs(users) {
  if (!Array.isArray(users)) return [];

  return users
    .map(user => {
      if (typeof user === 'object' && user !== null) {
        if ('userID' in user) {
          return { employeeID: user.userID };
        } else if ('employeeID' in user) {
          return { employeeID: user.employeeID };
        }
      }
      return null;
    })
    .filter(Boolean); // removes nulls
}